// @ts-nocheck
import Text from "src/components/text/text";
import Image from "src/components/image";
import {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useCallback,
  Suspense,
  useImperativeHandle,
  Ref,
  forwardRef,
  useMemo,
} from "react";
import { useNavigationStore } from "src/store/navigationStore";
import { EVENT, trackEvent } from "@/utils/analytics";
import {
  NavigationData,
  NavigationPath,
  NavigationSequence,
  NavigationCheckpointData,
} from "@/types/navigation";
import { useAppStore } from "@/store/appStore";
import { useLanguageStore } from "@/store/languageStore";
// import {
//   VenueModelConfig,
//   getVenueModelConfig,
//   getAltitudeByFloorIndex,
//   getFloorNameByFloorIndex,
// } from "src/const/venue_model/venue_model_config";

import { isLift, isEscalator } from "src/utils/navigation";
import { useLodSplat } from "src/utils/useLodSplat";

import {
  IMapAlign,
  calculateXy,
  getVenueShortNameById,
  getMapAlignById,
  getVenueModelConfigByVenueCode,
  getBaseUrl,
  getAltitudeByFloorIndex,
  getFloorNameByFloorIndex,
  getVenueIdByVenueCode,
  getStartPointNameByVenueCode,
  getEndPointNameByVenueCode,
} from "src/utils/map-util";
import { useNavigate } from "react-router-dom";

import Lottie from "lottie-react";
import loading from "src/components/lottie/loading.json";

import {
  getFloorIndex,
  getFloorNumber,
  getFloorString,
  getFloorStringWithIndex,
  getInterpolatedNumberArray,
  getLowerNumberArray,
  isLastNumberArray,
  GLB_AVATAR,
  getFloorNumberArray,
  initCameraMovement,
  hasChinese,
} from "src/const/navigationConst";

import WatermarkScreen from "src/components/watermark";
import useMessagePlayer from "@/hooks/useMessagePlayer";

import {
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  calculateLookAtRotation,
  interpolateVector3,
} from "src/utils/game";
import * as pc from "playcanvas";
import { OrbitControls } from "@playcanvas/react/scripts";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Anim,
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
} from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";
import { GsplatRevealRadial } from "src/extra_js/reveal-radial.mjs";
import useAudioPlayer from "@/hooks/useAudioPlayer";

export default function NavigationPage() {
  const setProgress = useNavigationStore((state) => state.setProgress);
  const setCalculatePosition = useNavigationStore(
    (state) => state.setCalculatePosition,
  );
  const setFullDistance = useNavigationStore((state) => state.setFullDistance);
  const setFullDuration = useNavigationStore((state) => state.setFullDuration);
  const setCurrentVenueId = useNavigationStore(
    (state) => state.setCurrentVenueId,
  );
  const setCurrentVenue = useNavigationStore((state) => state.setCurrentVenue);
  const setCurrentLevel = useNavigationStore((state) => state.setCurrentLevel);
  const setCurrentLevelIndex = useNavigationStore(
    (state) => state.setCurrentLevelIndex,
  );

  const setStartPointName = useNavigationStore(
    (state) => state.setStartPointName,
  );
  const setEndPointName = useNavigationStore((state) => state.setEndPointName);

  const setNavigationAngle = useNavigationStore(
    (state) => state.setNavigationAngle,
  );
  const setNavigationMessage = useNavigationStore(
    (state) => state.setNavigationMessage,
  );
  const setNavigationCheckpoint = useNavigationStore(
    (state) => state.setNavigationCheckpoint,
  );
  const setCameraMode = useNavigationStore((state) => state.setCameraMode);

  const setNavigationCameraPosition = useNavigationStore(
    (state) => state.setNavigationCameraPosition,
  );
  const setNavigationCameraLookingPosition = useNavigationStore(
    (state) => state.setNavigationCameraLookingPosition,
  );
  const setNavigationPercentagePositionDictionary = useNavigationStore(
    (state) => state.setNavigationPercentagePositionDictionary,
  );
  const startAutoPlayDelay = useNavigationStore(
    (state) => state.startAutoPlayDelay,
  );

  const enableXRayMode = useNavigationStore((state) => state.enableXRayMode);
  const setLoading = useNavigationStore((state) => state.setLoading);
  const setIsDisplayUI = useNavigationStore((state) => state.setIsDisplayUI);
  const setIsShowNavigationContinueButton = useNavigationStore(
    (state) => state.setIsShowNavigationContinueButton,
  );
  const setIsShowNavigationRestartButton = useNavigationStore(
    (state) => state.setIsShowNavigationRestartButton,
  );
  const setIsDisplayDragScreenSliderAnimation = useNavigationStore(
    (state) => state.setIsDisplayDragScreenSliderAnimation,
  );

  const navigate = useNavigate();

  //NEW

  const gsplatMainRef = useRef();

  const latestProgressRef = useRef<number>(0);
  const latestMapAlignRef = useRef<IMapAlign>(getMapAlignById(0));

  const AUTOPLAY_SPEED = 4;
  const autoPlaySpeedRef = useRef<number>(AUTOPLAY_SPEED);

  const [venueModelConfigState, setVenueModelConfigState] = useState<number>(0);
  const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);
  const [modelScaleFactorState, setModelScaleFactorState] = useState<number>(0);
  const isMouseDraggingRef = useRef<boolean>(false);
  const isMouseDraggingTimeoutRef = useRef<ReturnType<
    typeof setTimeout
  > | null>(null);
  const isTouchDraggingRef = useRef<boolean>(false);
  const isTouchDraggingTimeoutRef = useRef<ReturnType<
    typeof setTimeout
  > | null>(null);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestNavigationDataRef = useRef<NavigationData>(null);
  const latestNavigationPathRef = useRef<NavigationPath>(null);
  const latestCameraPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const latestNavigationMessage = useRef<string>("");

  const navigationPercentageMessageDictionaryRef = useRef<
    Record<number, string>
  >({});

  const currentLevelIndexRef = useRef<number>(0);
  const currentNextLevelIndexRef = useRef<number>(0);

  const navigationPositionArrayRef = useRef<pc.Vec3[]>([]);
  const navigationTargetArrayRef = useRef<pc.Vec3[]>([]);
  const navigationIdArrayRef = useRef<string[]>([]);
  const navigationLevelArrayRef = useRef<string[]>([]);

  const navigationObjectDesiredPositionRef = useRef<pc.Vec3>(
    new pc.Vec3(0, 0, 0),
  );
  const navigationObjectDesiredTargetRef = useRef<pc.Vec3>(
    new pc.Vec3(0, 0, 0),
  );

  const navigationFloorCamerasRef = useRef<Record<string, pc.Vec3[]>>({});

  const isAutoPlayingRef = useRef<boolean>(false);
  const isFirstAutoPlayedRef = useRef<boolean>(false);

  const autoPlayTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const latestCameraModeRef = useRef<number>(0);
  const latestXrayModeRef = useRef<number>(0);

  const navigationPercentageLevelDictionaryRef = useRef<Record<number, string>>(
    {},
  );
  const latestNavigationPercentageMessageDictionary = useRef<
    Record<number, string>
  >({});
  const latestNavigationPercentagePositionDictionary = useRef<
    Record<number, number[]>
  >({});
  const latestNavigationPercentageTargetDictionary = useRef<
    Record<number, number[]>
  >({});
  const latestNavigationPercentagePathTypeDictionary = useRef<
    Record<number, number>
  >({});
  const latestNavigationPercentageLevelIndexDictionary = useRef<
    Record<number, number>
  >({});

  const latestFullDuration = useRef<number>(0);
  const latestFullDistance = useRef<number>(0);

  //Init animation
  const isDisplayEnteringMaskRef = useRef<boolean>(false);
  const initAnimationRef = useRef("init");
  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const revealEffectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const isDisplayAvatarRef = useRef<boolean>(false);
  const isDisplayStartEndPointDivRef = useRef<boolean>(false);
  const isDisplayStartEndPointFirstRef = useRef<boolean>(false);
  const isDisplayStartEndPointSecondRef = useRef<boolean>(false);
  const isDisplayStartEndPointThirdRef = useRef<boolean>(false);
  const isDisplayStartEndPointStartRef = useRef<boolean>(false);
  const isDisplayStartEndPointEndRef = useRef<boolean>(false);

  //Preview
  const isEnableDragRef = useRef<boolean>(false);
  const isDisplayBlackScreenRef = useRef<boolean>(false);
  const finishPreviewTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  //Step by Step
  const isWaitingUserContinue = useRef<boolean>(false);
  const isNavigationHasChineseRef = useRef<boolean>(false);

  useEffect(() => {
    setCameraMode(1);
    return () => {
      console.log("unmounting");
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
      if (revealEffectTimeoutRef.current) {
        clearTimeout(revealEffectTimeoutRef.current);
      }
      if (finishPreviewTimeoutRef.current) {
        clearTimeout(finishPreviewTimeoutRef);
      }
      stopAutoPlay();
      setIsDisplayUI(false);
      setIsShowNavigationContinueButton(false);
      setIsShowNavigationRestartButton(false);
    };
  }, []);

  function backToHome() {
    console.log("back to home");
    navigate("/");
  }

  function stopAutoPlay() {
    console.log("stop auto play");
    isAutoPlayingRef.current = false;
    if (autoPlayTimeoutRef.current) {
      clearTimeout(autoPlayTimeoutRef.current);
      autoPlayTimeoutRef.current = null;
    }
  }

  function resumeAutoPlay(milliseconds: number) {
    console.log("resumeAutoPlay: milliseconds=", milliseconds);
    if (isMouseDraggingRef.current || isTouchDraggingRef.current) {
      console.log("user dragging");
      return;
    }
    if (milliseconds > 0) {
      stopAutoPlay();
    }
    autoPlayTimeoutRef.current = setTimeout(() => {
      console.log("resume auto play");
      autoPlayTimeoutRef.current = null;
      isAutoPlayingRef.current = true;
    }, milliseconds);
  }

  function findNearestFixedCamera(level: number, currentPos: pc.Vec3) {
    let nearestPos = null;
    let minDistance = Infinity;

    const currentLevelCameras =
      navigationFloorCamerasRef.current[level.toString()];

    for (const pos of currentLevelCameras) {
      const cameraPosVector = new pc.Vec3(pos.x, pos.y, -pos.z);

      const distance = vec3Distance(cameraPosVector, currentPos);
      if (distance < minDistance) {
        minDistance = distance;
        nearestPos = pos;
      }
    }
    if (nearestPos == null) {
      return new pc.Vec3(0, 0, 0);
    } else {
      return new pc.Vec3(nearestPos.x, nearestPos.y, -nearestPos.z);
    }
  }

  function updateNavigation(percentage: number, mode: number = 0) {
    if (
      Object.keys(latestNavigationPercentagePositionDictionary.current)
        .length == 0 ||
      Object.keys(latestNavigationPercentageTargetDictionary.current).length ==
      0
    ) {
      return;
    }
    if (
      Object.keys(latestNavigationPercentagePositionDictionary.current)
        .length !=
      Object.keys(latestNavigationPercentageTargetDictionary.current).length
    ) {
      return;
    }
    const currentLevelIndex = getFloorNumber(
      latestNavigationPercentageLevelIndexDictionary.current,
      percentage,
    );
    currentLevelIndexRef.current = currentLevelIndex;

    const currentLevelName = getFloorNameByFloorIndex(
      latestVenueModelConfigRef.current,
      currentLevelIndex,
    );
    // const currentMessage = getFloorString(
    //   latestNavigationPercentageMessageDictionary.current,
    //   percentage,
    // );
    // const currentMessageData = getFloorStringWithIndex(
    //   latestNavigationPercentageMessageDictionary.current,
    //   percentage,
    // );

    // const currentMessageIndex = currentMessageData.index;
    // const currentMessage = currentMessageData.string;

    const currentMessage = getFloorString(
      latestNavigationPercentageMessageDictionary.current,
      percentage,
    );

    const currentPathType = getFloorNumber(
      latestNavigationPercentagePathTypeDictionary.current,
      percentage,
    );

    const currentPosition = getInterpolatedNumberArray(
      latestNavigationPercentagePositionDictionary.current,
      percentage,
    );

    //const isLastTarget = isLastNumberArray(latestNavigationPercentageTargetDictionary.current, percentage);
    //console.log(isLastTarget + " " + percentage);

    // let currentTarget;

    // if(percentage < 1){
    //   currentTarget = getInterpolatedNumberArray(
    //     latestNavigationPercentageTargetDictionary.current,
    //     percentage,
    //   );
    // }
    // else{
    //   currentTarget = getLowerNumberArray(
    //     latestNavigationPercentageTargetDictionary.current,
    //     percentage,
    //   );
    // }

    //let currentTarget;

    // if(!isLastTarget){
    //   currentTarget = getInterpolatedNumberArray(
    //     latestNavigationPercentageTargetDictionary.current,
    //     percentage,
    //   );
    // }
    // else{
    //   currentTarget = getLowerNumberArray(
    //     latestNavigationPercentageTargetDictionary.current,
    //     percentage,
    //   );
    // }

    const currentTarget = getInterpolatedNumberArray(
      latestNavigationPercentageTargetDictionary.current,
      percentage,
    );

    if (initAnimationRef.current == "stepByStep") {
      if (latestNavigationMessage.current != currentMessage) {
        latestNavigationMessage.current = currentMessage;
        stopAutoPlay();
        isWaitingUserContinue.current = true;
        setIsShowNavigationContinueButton(true);
      }
    }

    if (initAnimationRef.current == "stepByStep" && percentage == 1) {
      setIsShowNavigationRestartButton(true);
    }

    if (initAnimationRef.current == "preview" && percentage == 1) {
      //TODO message
      if (isNavigationHasChineseRef.current) {
        setNavigationMessage("開始一步步講解");
      } else {
        setNavigationMessage("Start a step-by-step walkthrough.");
      }

      stopAutoPlay();
      finishPreview();
      if (finishPreviewTimeoutRef.current) {
        clearTimeout(finishPreviewTimeoutRef);
      }
      finishPreviewTimeoutRef.current = setTimeout(() => {
        isDisplayBlackScreenRef.current = true;
      }, 2000);
      finishPreviewTimeoutRef.current = setTimeout(() => {
        setCameraMode(0);
        isDisplayAvatarRef.current = false;
        resetSlider();
        resetPosition();
      }, 2500);
      finishPreviewTimeoutRef.current = setTimeout(() => {
        isDisplayBlackScreenRef.current = false;
        setIsDisplayUI(true);
        initAnimationRef.current = "stepByStep";
        isEnableDragRef.current = true;
        setIsDisplayDragScreenSliderAnimation(true);
      }, 3000);
      finishPreviewTimeoutRef.current = setTimeout(() => {
        resumeAutoPlay(0);
      }, 4000);
      finishPreviewTimeoutRef.current = setTimeout(() => {
        setIsDisplayDragScreenSliderAnimation(false);
      }, 5000);
    }

    if (initAnimationRef.current == "stepByStep") {
      setNavigationMessage(currentMessage);
    }

    setCurrentLevelIndex(currentLevelIndex);
    setCurrentLevel(currentLevelName);

    navigationObjectDesiredPositionRef.current.set(
      currentPosition[0],
      currentPosition[1],
      currentPosition[2],
    );

    navigationObjectDesiredTargetRef.current.set(
      currentTarget[0],
      currentTarget[1],
      currentTarget[2],
    );
  }

  function finishPreview() {
    console.log("finish preview !!!!!!");
  }

  function updatePath(pathIndex: number = 0) {
    if (
      latestNavigationDataRef.current == null ||
      latestNavigationDataRef.current.nav.length == 0
    )
      return;
    let newNavigationObject = JSON.parse(
      JSON.stringify(latestNavigationDataRef.current.nav[pathIndex]),
    );

    setStartPointName(newNavigationObject?.startingPoi?.name ?? "");
    setEndPointName(newNavigationObject?.endPoi?.name ?? "");

    //filter the first navigation node if the first two lat long is the same
    if (newNavigationObject.navigation.length >= 2) {
      if (
        newNavigationObject.navigation[0].lat ==
        newNavigationObject.navigation[1].lat &&
        newNavigationObject.navigation[0].lng ==
        newNavigationObject.navigation[1].lng
      ) {
        //remove first node
        newNavigationObject.navigation = [
          ...newNavigationObject.navigation.slice(1),
        ];
      }
    }

    // filter navigation node with 0 distance which is walk type and not the final node
    const lastNavigationIndex = newNavigationObject.navigation.length - 1;
    newNavigationObject.navigation = newNavigationObject.navigation.filter(
      (item: NavigationSequence, index: number) => {
        if (
          item.distance === 0 &&
          item.pathType === 1 &&
          index !== lastNavigationIndex
        ) {
          return false;
        }
        return true;
      },
    );

    //Ensure all lift and escalator distance is 0 , so we can standard the taking time.
    console.log(newNavigationObject.navigation);
    newNavigationObject.navigation.forEach(function (node, index, array) {
      if (isLift(node.pathType) || isEscalator(node.pathType)) {
        console.log("change " + node.message);
        node.distance = 0;
      }
    });

    //Check how many change floor first , handle distance == 0
    const FLOOR_CHANGE_DISTANCE = 5;
    let floorChangeTime = 0;
    newNavigationObject.navigation.forEach(function (node, index, array) {
      if (node.distance == 0) {
        floorChangeTime++;
      }
    });

    //As we override some distance , not using the total distance in json , manual sum up the distance
    let totalDistance = 0;
    newNavigationObject.navigation.forEach(function (node, index, array) {
      totalDistance += node.distance;
    });

    //Add extra floor distance
    totalDistance += floorChangeTime * FLOOR_CHANGE_DISTANCE;

    let processedDistance = 0;
    const poiLat = newNavigationObject.endPoi?.lat;
    const poiLng = newNavigationObject.endPoi?.lng;
    const poiLevelIndex = newNavigationObject.level;
    const newCheckpointArray: number[] = [];

    const currentNavigationPercentageMessageDictionary: Record<number, string> =
      {};
    const currentNavigationPercentagePositionDictionary: Record<
      number,
      number[]
    > = {};
    const currentNavigationPercentageTargetDictionary: Record<
      number,
      number[]
    > = {};
    const currentNavigationPercentagePathTypeDictionary: Record<
      number,
      number
    > = {};
    const currentNavigationPercentageLevelIndexDictionary: Record<
      number,
      number
    > = {};

    // let isAddClearMessage = false;

    let isSkipAfterLevelChange = false;
    newNavigationObject.navigation.forEach(function (node, index, array) {
      processedDistance =
        processedDistance > totalDistance ? totalDistance : processedDistance;
      const currentPercentage = processedDistance / totalDistance;
      const addDistance =
        node.distance <= 0 ? FLOOR_CHANGE_DISTANCE : node.distance;
      processedDistance += addDistance;

      currentNavigationPercentageLevelIndexDictionary[currentPercentage] =
        node.level;

      let altitude = getAltitudeByFloorIndex(
        latestVenueModelConfigRef.current,
        node.level,
      );
      let positionXy = calculateXy(
        latestMapAlignRef.current,
        node.lat,
        node.lng,
      );
      let markerXy;
      if (node.marker != null) {
        markerXy = calculateXy(
          latestMapAlignRef.current,
          node.marker.lat,
          node.marker.lng,
        );
      }
      let currentType = node.pathType;
      let currentMessage = node.message;

      currentNavigationPercentagePathTypeDictionary[currentPercentage] =
        currentType;

      if (currentPercentage == 0) {
        currentNavigationPercentageMessageDictionary[currentPercentage] = "";
      }

      // if (isAddClearMessage) {
      //   isAddClearMessage = false;
      //   currentNavigationPercentageMessageDictionary[currentPercentage] = "";
      // }

      // if (
      //   index == 0 ||
      //   index == array.length - 1 ||
      //   (currentType != 1 && currentMessage != null)
      // ) {

      if (isSkipAfterLevelChange) {
        //skip Continue ahead message
        isSkipAfterLevelChange = false;
        console.log("skip " + currentMessage);
      } else {
        if (index == array.length - 1 || currentMessage != null) {
          newCheckpointArray.push(currentPercentage);
          currentNavigationPercentageMessageDictionary[currentPercentage] =
            currentMessage;
          if (currentType != 1) {
            console.log("add flag skip " + currentType + " " + currentMessage);
            isSkipAfterLevelChange = true;
          }
        }
      }

      currentNavigationPercentagePositionDictionary[currentPercentage] = [
        -positionXy.x / modelScaleFactorState,
        altitude / modelScaleFactorState,
        -positionXy.y / modelScaleFactorState,
      ];

      if (index < array.length - 1) {
        const nextNode = array[index + 1];
        let nextNodeAltitude = getAltitudeByFloorIndex(
          latestVenueModelConfigRef.current,
          nextNode.level,
        );
        let nextNodePositionXy = calculateXy(
          latestMapAlignRef.current,
          nextNode.lat,
          nextNode.lng,
        );
        let nextNodeMarkerXy;
        if (nextNode.marker != null) {
          nextNodeMarkerXy = calculateXy(
            latestMapAlignRef.current,
            nextNode.marker.lat,
            nextNode.marker.lng,
          );
        }
        if (nextNodeMarkerXy != null) {
          currentNavigationPercentageTargetDictionary[currentPercentage] = [
            -nextNodeMarkerXy.x / modelScaleFactorState,
            // nextNodeAltitude / modelScaleFactorState,
            altitude / modelScaleFactorState,
            -nextNodeMarkerXy.y / modelScaleFactorState,
          ];
        } else {
          currentNavigationPercentageTargetDictionary[currentPercentage] = [
            -nextNodePositionXy.x / modelScaleFactorState,
            // nextNodeAltitude / modelScaleFactorState,
            altitude / modelScaleFactorState,
            -nextNodePositionXy.y / modelScaleFactorState,
          ];
        }
      } else {
        let poiXy = calculateXy(latestMapAlignRef.current, poiLat, poiLng);
        let poiAltitude = getAltitudeByFloorIndex(
          latestVenueModelConfigRef.current,
          poiLevelIndex,
        );
        currentNavigationPercentageTargetDictionary[currentPercentage] = [
          -poiXy.x / modelScaleFactorState,
          // poiAltitude / modelScaleFactorState,
          altitude / modelScaleFactorState,
          -poiXy.y / modelScaleFactorState,
        ];
      }
    });

    latestNavigationPercentageMessageDictionary.current =
      currentNavigationPercentageMessageDictionary;
    latestNavigationPercentagePositionDictionary.current =
      currentNavigationPercentagePositionDictionary;
    latestNavigationPercentageTargetDictionary.current =
      currentNavigationPercentageTargetDictionary;
    latestNavigationPercentagePathTypeDictionary.current =
      currentNavigationPercentagePathTypeDictionary;
    latestNavigationPercentageLevelIndexDictionary.current =
      currentNavigationPercentageLevelIndexDictionary;

    setFullDistance(newNavigationObject.distance);
    setFullDuration(newNavigationObject.duration);
    setNavigationCheckpoint(newCheckpointArray);
    setNavigationPercentagePositionDictionary(
      currentNavigationPercentagePositionDictionary,
    );
    resetSlider();
    resetPosition();

    console.log(currentNavigationPercentagePositionDictionary);
  }

  function resetPosition() {
    console.log("reset camera position");
    // setCameraMode(1);
    updateNavigation(0, -1);
  }

  function resetSlider() {
    console.log("reset slider");
    setNavigationMessage("");
    setProgress(0);
  }

  const DebugKeyListener = () => {
    useEffect(() => {
      const handleSpacePress = (event: KeyboardEvent) => {
        // if (event.key === '1') {
        //   setIsShowTopViewNavigation(true);
        // }
      };
      window.addEventListener("keydown", handleSpacePress);
      return () => {
        window.removeEventListener("keydown", handleSpacePress);
      };
    }, []);
    return <></>;
  };

  const LoadingMask = () => {
    const isLoading = useNavigationStore((state) => state.isLoading);
    useEffect(() => {
      console.log("isLoading: " + isLoading);
      if (isLoading) {
        stopAutoPlay();
      }
    }, [isLoading]);
    return isLoading ? (
      <div className="fixed inset-0 z-[60] flex items-center justify-center">
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-80 "></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const DataController = () => {
    const navData = useNavigationStore((state) => state.navData);
    useEffect(() => {
      console.log("navData changed");
      if (navData == null) {
        console.log("NO nav DATA");
        backToHome();
      } else {
        latestNavigationDataRef.current = navData;

        const isNavigationHasChinese = hasChinese(navData);
        isNavigationHasChineseRef.current = isNavigationHasChinese;

        const venueId = navData.nav[0].startingPoi.venueId ?? 0;
        setCurrentVenueId(venueId);

        const venueShortName = getVenueShortNameById(venueId).toLowerCase();
        setCurrentVenue(venueShortName);

        // const venueModelConfig = getVenueModelConfig(venueShortName);
        // console.log("#####");
        // console.log(venueModelConfig);

        // const startPointName = getStartPointNameByVenueCode(venueShortName);
        // setStartPointName(startPointName);
        // const endPointName = getEndPointNameByVenueCode(venueShortName);
        // setEndPointName("EEE");

        const venueModelConfig = getVenueModelConfigByVenueCode(venueShortName);
        console.log(venueModelConfig);

        setVenueModelConfigState(venueModelConfig);
        latestVenueModelConfigRef.current = venueModelConfig;
        setModelScaleFactorState(venueModelConfig.scaleFactor);

        const mapAlign = getMapAlignById(venueId);
        latestMapAlignRef.current = mapAlign;

        venueModelConfig.floor.forEach((floor) => {
          if (floor.cameras) {
            //console.log(floor.cameras);
            let floorCameras: pc.Vec3[] = [];
            floor.cameras.forEach((cameraPosition) => {
              //console.log(cameraPosition.length);
              if (cameraPosition.length == 3) {
                floorCameras.push(
                  new pc.Vec3(
                    Number(cameraPosition[0]) / venueModelConfig.scaleFactor,
                    Number(cameraPosition[1]) / venueModelConfig.scaleFactor,
                    Number(cameraPosition[2]) / venueModelConfig.scaleFactor,
                  ),
                );
              }
            });
            navigationFloorCamerasRef.current[floor.index.toString()] =
              floorCameras;
          }
        });

        updatePath();

        if (venueModelConfig && !venueModelConfig?.lod) {
          console.log("skip 3dGS !!!!");
          initAnimationRef.current = "orbit";
        }
      }
      return () => {
        stopAutoPlay();
        console.log("Component is unmounting");
      };
    }, [navData]);

    const progress = useNavigationStore((state) => state.progress);

    useEffect(() => {
      if (progress >= 0) {
        latestProgressRef.current = progress;
        updateNavigation(latestProgressRef.current);
      }
      // isCameraUpdating.current = true;
    }, [progress]);

    const fullDistance = useNavigationStore((state) => state.fullDistance);
    const fullDuration = useNavigationStore((state) => state.fullDuration);

    useEffect(() => {
      latestFullDistance.current = fullDistance;
      latestFullDuration.current = fullDuration;
    }, [fullDistance, fullDuration]);

    const startAutoPlayData = useNavigationStore(
      (state) => state.startAutoPlayData,
    );
    const resetStartAutoPlayDelay = useNavigationStore(
      (state) => state.resetStartAutoPlayDelay,
    );
    const stopAutoPlayData = useNavigationStore(
      (state) => state.stopAutoPlayData,
    );

    const cameraMode = useNavigationStore((state) => state.cameraMode);
    useEffect(() => {
      latestCameraModeRef.current = cameraMode;
    }, [cameraMode]);

    useEffect(() => {
      if (startAutoPlayData.delay < 0) {
        return;
      }
      if (!isFirstAutoPlayedRef.current) {
        //setCameraMode(0);
        isFirstAutoPlayedRef.current = true;
      }
      console.log("startAutoPlayData.delay=", startAutoPlayData.delay);
      resumeAutoPlay(startAutoPlayData.delay);
      resetStartAutoPlayDelay();
    }, [startAutoPlayData]);

    useEffect(() => {
      console.log("stopAutoPlayData=", stopAutoPlayData);
      if (stopAutoPlayData < 0) {
        return;
      }
      stopAutoPlay();
    }, [stopAutoPlayData]);

    const xRayMode = useNavigationStore((state) => state.xRayMode);

    useEffect(() => {
      latestXrayModeRef.current = xRayMode;
      if (gsplatMainRef.current?.gsplat) {
        const opacity = xRayMode === 2 ? 0.05 : 1.0;
        gsplatMainRef.current.gsplat.setWorkBufferModifier({
          glsl: `
            void modifySplatCenter(inout vec3 center) {}
            void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {}
            void modifySplatColor(vec3 center, inout vec4 color) { color.a *= ${opacity.toFixed(1)}; }
          `,
        });
      }

      if (xRayMode == 2) {
        setCameraMode(1);
      }
    }, [xRayMode]);

    const isLoading = useNavigationStore((state) => state.isLoading);
    const isInterrupt = useNavigationStore((state) => state.isInterrupt);
    const setInterrupt = useNavigationStore((state) => state.setInterrupt);
    const {
      playAudio,
      muteAudio,
      unmuteAudio,
      pauseAudio,
      resumeAudio,
      stopAudio,
    } = useAudioPlayer();
    // const { cancelReading } = useMessagePlayer();
    useEffect(() => {
      console.log("isInterrupt: " + isInterrupt + ", isLoading: " + isLoading);
      if (isInterrupt) {
        if (isLoading) {
          stopAutoPlay();
          resetPosition();
          resetSlider();
        }
        // cancelReading(); 
        console.log("isInterrupt stopAudio ");
        stopAudio()
        setInterrupt(false);
      }
    }, [isInterrupt]);
    return <></>;
  };

  const ChangeFloorScreen = () => {
    const isShowNavigationContinueButton = useNavigationStore(
      (state) => state.isShowNavigationContinueButton,
    );
    const isShowNavigationRestartButton = useNavigationStore(
      (state) => state.isShowNavigationRestartButton,
    );
    const [changeFloorScreenOpacity, setChangeFloorScreenOpacity] = useState(0);
    const [lastestTypeState, setLastestTypeState] = useState<string>("");

    const progress = useNavigationStore((state) => state.progress);
    useEffect(() => {
      const pathType = getFloorNumber(
        latestNavigationPercentagePathTypeDictionary.current,
        progress,
      );
      // if (pathType == 2 || pathType == 3 || pathType == 6 || pathType == 7) {
      if (
        (isLift(pathType) || isEscalator(pathType)) &&
        !isShowNavigationContinueButton &&
        !isShowNavigationRestartButton
      ) {
        setLastestTypeState(pathType);
        setChangeFloorScreenOpacity(1);
      } else {
        setChangeFloorScreenOpacity(0);
      }
    }, [
      progress,
      isShowNavigationContinueButton,
      isShowNavigationRestartButton,
    ]);

    return (
      <div>
        <div
          className="w-full h-full fixed top-0 left-0 pointer-events-none transition-opacity"
          style={{ opacity: changeFloorScreenOpacity }}
        // style={{ opacity: 1 }}
        >
          <div className="frosted-fullscreen flex flex-col items-center justify-center">
            <Image
              src={"/assets/icon_nav_" + lastestTypeState + "_black.png"}
              width={100}
              height={100}
            />
          </div>
        </div>
      </div>
    );
  };

  const NavigationAutoPlayController = () => {
    const app = useApp();

    let duration = -1;
    let eachProgress = -1;
    let _newProgress = 0;
    const releaseDelay = 2000;
    let _currentMouse = 0;
    let _currentTouch = 0;

    const handleUpdate = useCallback((dt: number) => {
      let isMouseUpdated =
        _currentMouse != cameraScriptRef.current._state.mouse[0];
      _currentMouse = cameraScriptRef.current._state.mouse[0];
      let isTouchUpdated =
        _currentTouch != cameraScriptRef.current._state.touches;
      _currentTouch = cameraScriptRef.current._state.touches;

      if (isMouseUpdated) {
        if (_currentMouse == 1) {
          console.log("mouse drag");
          stopAutoPlay();
          if (isMouseDraggingTimeoutRef.current != null) {
            clearTimeout(isMouseDraggingTimeoutRef.current);
            isMouseDraggingTimeoutRef.current = null;
          }
          trackEvent(EVENT.NAV_PAGE_3D_INTERACTION, {
            mode: "navigation",
            type: "mouse_drag",
          });
          isMouseDraggingRef.current = true;
        } else {
          console.log("mouse release");
          if (isMouseDraggingTimeoutRef.current != null) {
            clearTimeout(isMouseDraggingTimeoutRef.current);
            isMouseDraggingTimeoutRef.current = null;
          }
          isMouseDraggingTimeoutRef.current = setTimeout(() => {
            isMouseDraggingRef.current = false;
            if (!isWaitingUserContinue.current) {
              resumeAutoPlay(0);
            }
          }, releaseDelay);
        }
      }

      if (isTouchUpdated) {
        if (_currentTouch >= 1) {
          console.log("touch drag");
          stopAutoPlay();
          if (isTouchDraggingTimeoutRef.current != null) {
            clearTimeout(isTouchDraggingTimeoutRef.current);
            isTouchDraggingTimeoutRef.current = null;
          }
          isTouchDraggingRef.current = true;
          trackEvent(EVENT.NAV_PAGE_3D_INTERACTION, {
            mode: "navigation",
            type: "touch_drag",
          });
        } else {
          console.log("touch release");
          if (isTouchDraggingTimeoutRef.current != null) {
            clearTimeout(isTouchDraggingTimeoutRef.current);
            isTouchDraggingTimeoutRef.current = null;
          }
          isTouchDraggingTimeoutRef.current = setTimeout(() => {
            isTouchDraggingRef.current = false;
            if (!isWaitingUserContinue.current) {
              resumeAutoPlay(0);
            }
          }, releaseDelay);
        }
      }

      if (duration == -1) {
        duration = latestFullDuration.current;
      }
      if (isAutoPlayingRef.current) {
        eachProgress = (dt / duration) * autoPlaySpeedRef.current;
        _newProgress =
          latestProgressRef.current + eachProgress > 1
            ? 1
            : latestProgressRef.current + eachProgress;
        setProgress(_newProgress);
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return <></>;
  };

  const FloorMeshContainer = () => {
    const baseUrl = getBaseUrl();
    const floorMeshPosition = venueModelConfigState.floorMeshPosition;
    const floorMeshUrl =
      baseUrl +
      venueModelConfigState!.folderPath +
      venueModelConfigState.floorMesh;
    return floorMeshUrl != "" ? (
      <FloorMesh
        floorMeshUrl={floorMeshUrl}
        floorMeshPosition={floorMeshPosition}
      />
    ) : (
      <></>
    );
  };

  const FloorMesh = ({
    floorMeshUrl,
    floorMeshPosition,
  }: {
    floorMeshUrl: string;
    floorMeshPosition: pc.Vec3;
  }) => {
    const floorMeshEntityRef = useRef();
    const { asset: floorMeshAsset } = useModel(floorMeshUrl);

    const changeMaterial = (entity) => {
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (floorMeshAsset && floorMeshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(floorMeshEntityRef.current);
        });
      }
    }, [floorMeshAsset]);

    return (
      <Entity
        ref={floorMeshEntityRef}
        rotation={[0, 180, 0]}
        position={[
          floorMeshPosition[0] / modelScaleFactorState,
          floorMeshPosition[1] / modelScaleFactorState,
          floorMeshPosition[2] / modelScaleFactorState,
        ]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <Render type="asset" asset={floorMeshAsset} />
      </Entity>
    );
  };

  const NavigationAvatar = () => {
    const app = useApp();
    const avatarEntityRef = useRef();
    let floatTime = 0;
    const _avatarPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const { asset: robot } = useModel(GLB_AVATAR);
    const changeMaterial = (entity) => {
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };

    useEffect(() => {
      if (robot && avatarEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(avatarEntityRef.current);
        });
      }
    }, [robot]);

    const handleUpdate = useCallback((dt: number) => {
      floatTime += dt;
      if (avatarEntityRef.current) {
        _avatarPositionRef.current.set(0, Math.sin(floatTime * 2) * 0.05, 0);
        avatarEntityRef.current.setLocalPosition(_avatarPositionRef.current);
        avatarEntityRef.current.enabled =
          (initAnimationRef.current == "stepByStep" &&
            latestCameraModeRef.current == 1 &&
            latestXrayModeRef.current != 2) ||
          isDisplayAvatarRef.current;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return robot ? (
      <Entity position={[0, -1, 0]}>
        <Entity
          ref={avatarEntityRef}
          rotation={[10, 180, 0]}
          position={[0, 0, 0]}
          scale={[1, 1, 1]}
        >
          <Render type="asset" asset={robot} />
        </Entity>
      </Entity>
    ) : (
      <></>
    );
  };

  const cleanup = (app, gsplatEntity) => {
    const cleanup = installCameraNearFar(app, gsplatEntity);
    return cleanup;
  };

  const VenueLod = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const { asset, loading, error, lodDistances } = useLodSplat(
      //venueModelConfigState!.baseUrl + venueModelConfigState!.lod,
      baseUrl + venueModelConfigState!.folderPath + venueModelConfigState!.lod,
    );

    const createRadialScript = () => {
      const revealSpped = venueModelConfigState.revealSpeed ?? 10;
      const mainObjectPosition = mainObjectEntityRef.current.getPosition();
      const script = gsplatMainRef.current.script?.create(GsplatRevealRadial);
      if (script) {
        script.center.set(
          mainObjectPosition.x,
          mainObjectPosition.y,
          mainObjectPosition.z,
        );
        script.speed = revealSpped;
        script.acceleration = 0;
        script.delay = 1.2;
        script.dotTint.set(0, 1, 1); // Cyan
        script.waveTint.set(0, 1, 0); // Orange
        script.oscillationIntensity = 1;
        script.endRadius = 10000;
      }
      return script;
    };

    console.log(
      "LOAD!!! " +
      baseUrl +
      venueModelConfigState!.folderPath +
      venueModelConfigState!.lod,
    );

    useEffect(() => {
      isDisplayEnteringMaskRef.current = true;
    }, []);

    useEffect(() => {
      if (!asset) {
        return;
      }
      const gsplatEntity = gsplatMainRef.current;
      if (!gsplatMainRef.current || !app) return;
      gsplatMainRef.current.gsplat.enabled = false;
      gsplatMainRef.current.gsplat.unified = true;
      gsplatMainRef.current.gsplat.asset = asset;
      gsplatMainRef.current.gsplat.lodDistances = [
        20 * modelScaleFactorState,
        100 * modelScaleFactorState,
        500 * modelScaleFactorState,
      ];
      //gsplatMainRef.current.gsplat.enabled = true;
      enableXRayMode();
      gsplatEntity.addComponent("script");
      transitionTimeoutRef.current = setTimeout(() => {
        initAnimationRef.current = "orbit";
      }, 1000);
      revealEffectTimeoutRef.current = setTimeout(() => {
        if (gsplatMainRef.current) {
          gsplatMainRef.current.gsplat.enabled = true;
          createRadialScript();
        }
      }, 1000);
    }, [asset]);

    return (
      <Entity
        ref={gsplatMainRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <GSplat />
      </Entity>
    );
  };

  const MainCamera = () => {
    const app = useApp();
    const cameraRef = useRef();
    let _localProgress;
    let _localCameraMode;

    let previousRotationY = 0;

    let finalCameraPosition = new pc.Vec3(0, 0, 0);
    let finalCameraLookingPosition = new pc.Vec3(0, 0, 0);

    let orbitAnimationTime = 0;
    const orbitDuration = 5;

    const handleUpdate = useCallback((dt: number) => {
      if (cameraScriptRef.current == null) {
        return;
      }
      let isProgressUpdated = false;
      if (_localProgress != latestProgressRef.current) {
        _localProgress = latestProgressRef.current;
        isProgressUpdated = true;
      }
      let isCameraModeUpdated = false;
      if (_localCameraMode != latestCameraModeRef.current) {
        _localCameraMode = latestCameraModeRef.current;
        isCameraModeUpdated = true;
      }

      if (initAnimationRef.current == "init") {
        isDisplayEnteringMaskRef.current = true;
        isDisplayStartEndPointDivRef.current = true;
        isDisplayStartEndPointFirstRef.current = true;
        isDisplayAvatarRef.current = true;
        const offsetLocal = new pc.Vec3(0, 0, -3);
        const offsetWorld = firstPersonCameraEntityRef.current
          .getRotation()
          .transformVector(offsetLocal);
        const newPos = firstPersonCameraEntityRef.current
          .getPosition()
          .clone()
          .add(offsetWorld);
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPos,
        );
      } else if (initAnimationRef.current == "orbit") {
        isDisplayAvatarRef.current = true;
        isDisplayEnteringMaskRef.current = false;
        if (orbitAnimationTime <= 0.5) {
          isDisplayStartEndPointFirstRef.current = false;
          isDisplayStartEndPointSecondRef.current = true;
        } else if (orbitAnimationTime <= 1) {
          isDisplayStartEndPointSecondRef.current = true;
          isDisplayStartEndPointStartRef.current = true;
        } else if (orbitAnimationTime <= 2) {
          isDisplayStartEndPointSecondRef.current = false;
          isDisplayStartEndPointThirdRef.current = true;
          isDisplayStartEndPointEndRef.current = true;
        } else if (orbitAnimationTime > 3.5) {
          isDisplayStartEndPointFirstRef.current = false;
          isDisplayStartEndPointSecondRef.current = false;
          isDisplayStartEndPointThirdRef.current = false;
          isDisplayStartEndPointStartRef.current = false;
          isDisplayStartEndPointEndRef.current = false;
        }

        if (orbitAnimationTime >= orbitDuration) {
          cameraScriptRef.current.reset(
            mainObjectEntityRef.current.getPosition(),
            thirdPersonCameraEntityRef.current.getPosition(),
          );
          initAnimationRef.current = "preview";
          // isDisplayAvatarRef.current = false;
          // isEnableDragRef.current = true;
          setCameraMode(1);
          isDisplayStartEndPointDivRef.current = false;
          // setIsDisplayUI(true);
          setLoading(false);
          startAutoPlayDelay(0);
          if (gsplatMainRef.current) {
            cleanup(app, gsplatMainRef.current);
          }
          return;
        }
        orbitAnimationTime += dt;
        const t = Math.min(orbitAnimationTime / orbitDuration, 1);
        const newCameraPosition = interpolateVector3(initCameraMovement, t);
        const offsetLocal = new pc.Vec3(
          -newCameraPosition[0],
          newCameraPosition[1],
          -newCameraPosition[2],
        );
        const offsetWorld = firstPersonCameraEntityRef.current
          .getRotation()
          .transformVector(offsetLocal);
        const newPos = firstPersonCameraEntityRef.current
          .getPosition()
          .clone()
          .add(offsetWorld);
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPos,
        );
      } else if (initAnimationRef.current == "preview") {
        const mainObject = mainObjectEntityRef.current;
        const mainObjectPosition = mainObject.getPosition().clone();
        if (isProgressUpdated) {
          finalCameraLookingPosition = mainObjectPosition.clone();
          finalCameraPosition =
            thirdPersonCameraEntityRef.current.getPosition();
          cameraScriptRef.current.reset(
            finalCameraLookingPosition,
            finalCameraPosition,
          );
          latestCameraPositionRef.current = finalCameraPosition;
          const cameraAngle = getYAngleDegree(
            firstPersonCameraEntityRef.current.getPosition(),
            navigationObjectDesiredPositionRef.current,
          );
          setNavigationAngle(cameraAngle);
          setNavigationCameraPosition(finalCameraPosition);
          setNavigationCameraLookingPosition(finalCameraLookingPosition);
        }
      } else if (initAnimationRef.current == "stepByStep") {
        const mainObject = mainObjectEntityRef.current;
        const mainObjectPosition = mainObject.getPosition().clone();

        // console.log("1");
        // console.log(mainObjectPosition);
        // console.log("2");
        // console.log(finalCameraLookingPosition);

        // const updateDistance = vec3Distance(mainObjectPosition, finalCameraLookingPosition);
        // console.log(updateDistance);

        if (
          isProgressUpdated ||
          isCameraModeUpdated ||
          (isMouseDraggingRef.current == false &&
            isTouchDraggingRef.current == false)
        ) {
          if (_localCameraMode == 0) {
            const forward = mainObject.forward.clone().mulScalar(-0.1);
            finalCameraLookingPosition = mainObjectPosition.clone();
            finalCameraPosition = mainObjectPosition.add(forward);
          } else {
            finalCameraLookingPosition = mainObjectPosition.clone();
            finalCameraPosition =
              thirdPersonCameraEntityRef.current.getPosition();
          }

          cameraScriptRef.current.reset(
            finalCameraLookingPosition,
            finalCameraPosition,
          );

          latestCameraPositionRef.current = finalCameraPosition;
          const cameraAngle = getYAngleDegree(
            firstPersonCameraEntityRef.current.getPosition(),
            navigationObjectDesiredPositionRef.current,
          );

          setNavigationAngle(cameraAngle);
          setNavigationCameraPosition(finalCameraPosition);
          setNavigationCameraLookingPosition(finalCameraLookingPosition);
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState + 1,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      const defaultPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      mainObjectEntityRef.current.setPosition(defaultPosition);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    return (
      <Entity>
        <Camera />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -0.5]}></Entity>
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();
    const cameraRef = useRef();
    let previousRotationY = 0;

    const handleUpdate = useCallback((dt: number) => {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      const distance = vec3Distance(
        mainObjectEntityRef.current.localPosition,
        navigationObjectDesiredPositionRef.current,
      );

      const lerpPosition = mainObjectEntityRef.current.getPosition();
      lerpPosition.lerp(
        lerpPosition,
        navigationObjectDesiredPositionRef.current,
        dt * 5,
      );
      mainObjectEntityRef.current.setPosition(lerpPosition);

      const targetRotation = calculateLookAtRotation(
        navigationObjectDesiredPositionRef.current,
        navigationObjectDesiredTargetRef.current,
      );

      const lerpRotation = mainObjectEntityRef.current.getRotation();
      lerpRotation.lerp(lerpRotation, targetRotation, dt * 5);
      mainObjectEntityRef.current.setRotation(lerpRotation);
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={mainObjectEntityRef}>
        <NavigationAvatar />
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.5]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.3, 4]}
        ></Entity>
      </Entity>
    );
  };

  const installCameraNearFar = (
    app: pc.Application,
    gsplatEntity: pc.Entity,
  ) => {
    const device = app.graphicsDevice;
    const gsplatMat =
      app.scene.gsplat.material || gsplatEntity.gsplat?.material;
    if (!gsplatMat) return () => { };

    if (!hiddenNearRef.current || !hiddenFarRef.current) {
      return () => { };
    }

    const glsl = `
      uniform vec3 uCutA;       // camera position in WORLD space
      uniform vec3 uCutB;       // robot position in WORLD space
      uniform float uCutRadius; // cylinder radius of the cutaway
      uniform float uCutFeather;// soft edge transition distance

      // Calculate the shortest distance from a point (p) to a line segment (a to b)
      float segDist(vec3 p, vec3 a, vec3 b) {
        vec3 pa = p - a;
        vec3 ba = b - a;
        float h = clamp(dot(pa, ba) / max(dot(ba, ba), 1e-6), 0.0, 1.0);
        return length(pa - ba * h);
      }

      void modifySplatCenter(inout vec3 center) {
      }

      void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {
        // Calculate distance between current splat and the Camera-Robot line segment
        float d = segDist(originalCenter, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);

        // Scale down splats that are too close to the line to 0, making them disappear
        scale *= alpha;
      }

      void modifySplatColor(vec3 center, inout vec4 color) {
        // Apply the same transition to the alpha channel as a double-safeguard
        float d = segDist(center, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);
        color.a *= alpha;
      }
    `;

    gsplatMat.getShaderChunks("glsl").set("gsplatModifyVS", glsl);
    gsplatMat.update();
    const uCutA = device.scope.resolve("uCutA");
    const uCutB = device.scope.resolve("uCutB");
    const uCutRadius = device.scope.resolve("uCutRadius");
    const uCutFeather = device.scope.resolve("uCutFeather");
    uCutRadius.setValue(1);
    uCutFeather.setValue(0.01);
    const onUpdate = () => {
      if (!hiddenNearRef.current || !hiddenFarRef.current) {
        return;
      }
      const nearPosition = hiddenNearRef.current.getPosition().clone();
      const farPosition = hiddenFarRef.current.getPosition().clone();
      if (nearPosition.length() === 0 || isNaN(nearPosition.x)) return;
      const dirToCamera = new pc.Vec3().sub2(nearPosition, farPosition);
      const totalDist = dirToCamera.length();
      dirToCamera.normalize();
      uCutA.setValue([nearPosition.x, nearPosition.y, nearPosition.z]);
      uCutB.setValue([farPosition.x, farPosition.y, farPosition.z]);
    };

    app.on("update", onUpdate);
    return () => app.off("update", onUpdate);
  };

  const WalkPathsContainer = () => {
    const app = useApp();
    const isPointsSetup = useRef<boolean>(false);
    const [points, setPoints] = useState<number[][] | null>(null);

    const handleUpdate = useCallback((dt: number) => {
      if (
        !isPointsSetup.current &&
        latestNavigationPercentagePositionDictionary.current
      ) {
        let points = [];
        const entries = Object.entries(
          latestNavigationPercentagePositionDictionary.current,
        );
        for (let i = 0; i < entries.length; i++) {
          points.push(entries[i][1]);
        }
        setPoints([...points]);
        isPointsSetup.current = true;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return points != null ? <WalkPaths points={points} /> : <></>;
  };

  const WalkPaths = ({ points }: { points: number[][] }) => {
    const segments = points.slice(0, -1).map((start, i) => {
      const end = points[i + 1];
      const length = Math.hypot(
        end[0] - start[0],
        end[1] - start[1],
        end[2] - start[2],
      );
      return (
        <Fragment key={i}>
          <EachWalkPath
            start={start}
            end={end}
            length={length}
            pathIndex={i + 1}
            pathLength={points.length - 1}
          />
        </Fragment>
      );
    });
    return (
      <>
        {segments}
        <ExtraWalkPath points={points} />
      </>
    );
  };

  const ExtraWalkPath = ({ points }: { points: number[][] }) => {
    const app = useApp();
    let _localNavigationCameraPosition;
    let isCameraNavigationPositionUpdated;

    const _startPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const _endPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

    const entityRef = useRef();
    const innerBoxRef = useRef();
    const outerBoxRef = useRef();
    const outerBox2Ref = useRef();
    const outerBox3Ref = useRef();

    useEffect(() => {
      const innerMeshInstance = innerBoxRef.current.render.meshInstances[0];
      const innerMaterial = innerMeshInstance.material;
      const newInnerMaterial = innerMaterial.clone();
      innerMeshInstance.material = newInnerMaterial;
      newInnerMaterial.emissiveMap = newInnerMaterial.diffuseMap;
      newInnerMaterial.emissiveIntensity = 2.5;
      newInnerMaterial.useLighting = false;
      newInnerMaterial.useSkybox = false;
      newInnerMaterial.emissive.set(1, 1, 0.176);
      // newInnerMaterial.diffuse.set(0.663, 0.663, 0.027);
      newInnerMaterial.blendType = pc.BLEND_NONE;

      const outerRefs = [outerBoxRef, outerBox2Ref, outerBox3Ref];
      const opacities = [0.5, 0.2, 0.1];

      outerRefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;

          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(0.996, 0.184, 0.016);
          material.useLighting = false;
          material.useSkybox = false;
          material.blendType = pc.BLEND_ADDITIVEALPHA;
          material.opacity = opacities[index];
          material.update();
        }
      });
    }, []);

    const handleUpdate = useCallback((dt: number) => {
      if (
        entityRef.current == null ||
        latestProgressRef.current == 0 ||
        latestProgressRef.current >= 0.999
      ) {
        entityRef.current.enabled = false;
        return;
      }
      const currentPosition = getInterpolatedNumberArray(
        latestNavigationPercentagePositionDictionary.current,
        latestProgressRef.current,
      );

      const startPosition = getFloorNumberArray(
        latestNavigationPercentagePositionDictionary.current,
        latestProgressRef.current,
      );
      _startPositionRef.current.set(
        startPosition[0],
        startPosition[1],
        startPosition[2],
      );
      _endPositionRef.current.set(
        currentPosition[0],
        currentPosition[1],
        currentPosition[2],
      );
      const length = Math.hypot(
        _endPositionRef.current.x - _startPositionRef.current.x,
        _endPositionRef.current.y - _startPositionRef.current.y,
        _endPositionRef.current.z - _startPositionRef.current.z,
      );
      entityRef.current.setPosition(_startPositionRef.current);
      entityRef.current.lookAt(_endPositionRef.current);
      if (_startPositionRef.current.y == _endPositionRef.current.y) {
        entityRef.current.setLocalScale(0.05, 0.05, length);
        entityRef.current.translateLocal(0, -0.5, -length / 2);
      } else {
        entityRef.current.setLocalScale(0.05, 0.05, length + 0.075);
        entityRef.current.translateLocal(0, -0.45, -length / 2 + 0.2);
      }
      entityRef.current.enabled =
        latestXrayModeRef.current == 2 && latestCameraModeRef.current == 1;
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={entityRef}>
        <Entity ref={innerBoxRef} scale={[1, 1, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBoxRef} scale={[1.2, 1.2, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox2Ref} scale={[1.4, 1.4, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox3Ref} scale={[1.6, 1.6, 1]}>
          <Render type="box" />
        </Entity>
      </Entity>
    );
  };

  const EachWalkPath = ({ start, end, length, pathIndex, pathLength }) => {
    const app = useApp();
    const entityRef = useRef();
    const innerBoxRef = useRef();
    const outerBoxRef = useRef();
    const outerBox2Ref = useRef();
    const outerBox3Ref = useRef();

    const pathCorrespondingPercentage = useRef<number>(-1);

    useEffect(() => {
      const innerMeshInstance = innerBoxRef.current.render.meshInstances[0];
      const innerMaterial = innerMeshInstance.material;
      const newInnerMaterial = innerMaterial.clone();
      innerMeshInstance.material = newInnerMaterial;
      newInnerMaterial.emissiveMap = newInnerMaterial.diffuseMap;
      newInnerMaterial.emissiveIntensity = 2.5;
      newInnerMaterial.useLighting = false;
      newInnerMaterial.useSkybox = false;
      newInnerMaterial.emissive.set(1, 1, 0.176);
      // newInnerMaterial.diffuse.set(0.663, 0.663, 0.027);
      newInnerMaterial.blendType = pc.BLEND_NONE;

      const outerRefs = [outerBoxRef, outerBox2Ref, outerBox3Ref];
      const opacities = [0.5, 0.2, 0.1];

      outerRefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;

          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(0.996, 0.184, 0.016);
          material.useLighting = false;
          material.useSkybox = false;
          material.blendType = pc.BLEND_ADDITIVEALPHA;
          material.opacity = opacities[index];
          material.update();
        }
      });

      entityRef.current.setPosition(new pc.Vec3(start[0], start[1], start[2]));
      entityRef.current.lookAt(new pc.Vec3(end[0], end[1], end[2]));
      if (start[1] == end[1]) {
        entityRef.current.setLocalScale(0.05, 0.05, length);
        entityRef.current.translateLocal(0, -0.5, -length / 2);
      } else {
        entityRef.current.setLocalScale(0.05, 0.05, length + 0.075);
        entityRef.current.translateLocal(0, -0.45, -length / 2 + 0.2);
      }

      entityRef.current.enabled = false;
    }, []);

    const handleUpdate = useCallback((dt: number) => {
      if (entityRef.current == null) {
        return;
      }
      if (pathCorrespondingPercentage.current == -1) {
        const entries = Object.entries(
          latestNavigationPercentagePositionDictionary.current,
        );
        for (let i = 0; i < entries.length; i++) {
          if (
            end[0] == entries[i][1][0] &&
            end[1] == entries[i][1][1] &&
            end[2] == entries[i][1][2]
          ) {
            pathCorrespondingPercentage.current = entries[i][0];
          }
        }
      }
      if (
        latestProgressRef.current > pathCorrespondingPercentage.current &&
        latestXrayModeRef.current == 2 &&
        latestCameraModeRef.current == 1
      ) {
        entityRef.current.enabled = true;
      } else {
        entityRef.current.enabled = false;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={entityRef}>
        <Entity ref={innerBoxRef} scale={[1, 1, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBoxRef} scale={[1.2, 1.2, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox2Ref} scale={[1.4, 1.4, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox3Ref} scale={[1.6, 1.6, 1]}>
          <Render type="box" />
        </Entity>
      </Entity>
    );
  };

  const MeshModels = () => {
    const baseUrl = getBaseUrl();
    return (
      <>
        {venueModelConfigState!.mesh.meshModels.map((item, index) => (
          <MeshModel
            key={item.index}
            meshUrl={baseUrl + venueModelConfigState!.folderPath + item.url}
            meshPosition={item.position}
            meshRotationAngle={item.rotationAngle}
            meshScale={item.scale}
            meshColor={item.color ?? "#FFFFFF"}
            meshOpacity={item.opacity ?? 1}
            rotateObjects={item.rotateObjects ?? []}
          />
        ))}
      </>
    );
  };

  const MeshModel = ({
    meshUrl,
    meshPosition,
    meshRotationAngle,
    meshScale,
    meshColor,
    meshOpacity,
    rotateObjects,
  }: {
    meshUrl: string;
    meshPosition: number[];
    meshRotationAngle: number[];
    meshScale: number[];
    meshColor: string;
    meshOpacity: number;
    rotateObjects: string[];
  }) => {
    const meshEntityRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);

    //const { asset: meshAsset } = useModel("http:assets.deepworldmodel.ai/venue/floor_mesh/wksFloor_20260113_1800.glb");
    const color = hexToRgbArray(meshColor);

    const handleUpdate = useCallback((dt: number) => {
      rotateObjects.forEach((eachObject) => {
        const childEntity = meshEntityRef.current.findByName(eachObject);
        if (childEntity) {
          const rotationY = getYAngleDegree(
            childEntity.getPosition(),
            cameraScriptRef.current.entity.getPosition(),
          );
          childEntity.setEulerAngles(0, -rotationY, 0);
        }
      });
    }, []);
    useAppEvent("update", handleUpdate);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(color[0], color[1], color[2]);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(meshEntityRef.current);
        });

        //console.log(meshEntityRef.current.findComponents("anim"));

        // if (!meshEntityRef.current.anim) {
        //   meshEntityRef.current.addComponent("anim"); // creates entity.anim
        // }

        // console.log(meshEntityRef.current.anim);
        // console.log(meshEntityRef.current.animationAssets);
      }
    }, [meshAsset]);

    return (
      <Entity
        ref={meshEntityRef}
        position={[
          meshPosition[0] / modelScaleFactorState,
          meshPosition[1] / modelScaleFactorState,
          meshPosition[2] / modelScaleFactorState,
        ]}
        rotation={meshRotationAngle}
        scale={[
          meshScale[0] / modelScaleFactorState,
          meshScale[1] / modelScaleFactorState,
          meshScale[2] / modelScaleFactorState,
        ]}
      >
        <Render type="asset" asset={meshAsset} />
      </Entity>
    );
  };

  // const SimpleModel = () => {
  //   const meshEntityRef = useRef();
  //   const { asset: meshAsset } = useModel("model/exitOnly.glb");

  //   useEffect(() => {
  //     if (meshAsset && meshEntityRef.current) {
  //       console.log(meshEntityRef.current);

  //       const skinnedEntity = findSkinnedEntity(meshEntityRef.current);
  //       console.log("@@@@@");
  //       console.log(skinnedEntity);
  //     }
  //   }, [meshAsset]);

  //   return (
  //     <Entity
  //       ref={meshEntityRef}
  //       position={[
  //         -1100 / 16.2469536962,
  //         0 / 16.2469536962,
  //         -365.5 / 16.2469536962,
  //       ]}
  //       rotation={[0, 180, 0]}
  //       scale={[
  //         455 / 16.2469536962,
  //         455 / 16.2469536962,
  //         455 / 16.2469536962,
  //       ]}
  //     >
  //       <Render type="asset" asset={meshAsset} />
  //     </Entity>
  //   );
  // }

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        {/*<SimpleModel />*/}
        <WalkPathsContainer />
        <NavigationAutoPlayController />
        {venueModelConfigState!.lod ? <VenueLod /> : <></>}
        {venueModelConfigState!.mesh ? <MeshModels /> : <></>}
        {venueModelConfigState!.floorMesh ? <FloorMeshContainer /> : <></>}
        <Environment exposure={1} luminance={0.4} /> {/* Ambient fill */}
        <Entity>{/*<Light type="directional" intensity={50} />*/}</Entity>
        <MainObject />
        <MainCamera />
      </>
    );
  };

  const Scene = () => {
    return (
      <Application>
        {venueModelConfigState != null && modelScaleFactorState > 0 ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const EnterLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(true);
    const opacityRef = useRef<number>(1);
    const divRef = useRef<HTMLDivElement>(null);
    const EACH_OPACITY = 0.02;
    const animationRef = useRef<number>(0);
    const keepCheckLoading = () => {
      if (!isDisplayEnteringMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const StartEndPoint = () => {
    const animationRef = useRef<number>(0);
    const EACH_OPACITY = 0.02;
    const startPointName = useNavigationStore((state) => state.startPointName);
    const endPointName = useNavigationStore((state) => state.endPointName);
    const divRef = useRef<HTMLDivElement>(null);
    const firstRef = useRef<HTMLDivElement>(null);
    const firstOpacityRef = useRef<number>(0);
    const secondRef = useRef<HTMLDivElement>(null);
    const secondOpacityRef = useRef<number>(0);
    const thirdRef = useRef<HTMLDivElement>(null);
    const thirdOpacityRef = useRef<number>(0);
    const startPointRef = useRef<HTMLDivElement>(null);
    const startPointOpacityRef = useRef<number>(0);
    const endPointRef = useRef<HTMLDivElement>(null);
    const endPointOpacityRef = useRef<number>(0);
    const keepCheckLoading = () => {
      if (!isDisplayStartEndPointFirstRef.current) {
        firstOpacityRef.current =
          firstOpacityRef.current > EACH_OPACITY
            ? firstOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        firstOpacityRef.current =
          firstOpacityRef.current < 1 - EACH_OPACITY
            ? firstOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointSecondRef.current) {
        secondOpacityRef.current =
          secondOpacityRef.current > EACH_OPACITY
            ? secondOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        secondOpacityRef.current =
          secondOpacityRef.current < 1 - EACH_OPACITY
            ? secondOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointThirdRef.current) {
        thirdOpacityRef.current =
          thirdOpacityRef.current > EACH_OPACITY
            ? thirdOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        thirdOpacityRef.current =
          thirdOpacityRef.current < 1 - EACH_OPACITY
            ? thirdOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointStartRef.current) {
        startPointOpacityRef.current =
          startPointOpacityRef.current > EACH_OPACITY
            ? startPointOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        startPointOpacityRef.current =
          startPointOpacityRef.current < 1 - EACH_OPACITY
            ? startPointOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointEndRef.current) {
        endPointOpacityRef.current =
          endPointOpacityRef.current > EACH_OPACITY
            ? endPointOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        endPointOpacityRef.current =
          endPointOpacityRef.current < 1 - EACH_OPACITY
            ? endPointOpacityRef.current + EACH_OPACITY
            : 1;
      }
      divRef.current.style.display = isDisplayStartEndPointDivRef.current
        ? ""
        : "none";
      firstRef.current.style.opacity = firstOpacityRef.current.toString();
      secondRef.current.style.opacity = secondOpacityRef.current.toString();
      thirdRef.current.style.opacity = thirdOpacityRef.current.toString();
      startPointRef.current.style.opacity =
        startPointOpacityRef.current.toString();
      endPointRef.current.style.opacity = endPointOpacityRef.current.toString();
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return (
      <div ref={divRef} className={`fullscreen_div pointer-events-none`}>
        <div ref={firstRef}>
          <div className={`fullscreen_div flex items-center justify-center`}>
            <div className="w-full h-[4px] bg-[#E5E9EDE5]"></div>
          </div>
        </div>

        <div ref={secondRef}>
          <div className="absolute top-1/2 -translate-y-1/2 left-[0px] w-[calc(72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div className="absolute top-1/2 -translate-y-1/2 left-[calc(72px+6px+5px)] w-[calc(100%-72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>

          <div
            className={`absolute top-1/2 -translate-x-1/2 left-[72px] translate-y-[calc(-50%-9px)]`}
          >
            <Image src="/assets/icon_start_point.png" width={12} />
          </div>
        </div>

        <div ref={thirdRef}>
          <div className="absolute top-1/2 -translate-y-1/2 left-[0px] w-[calc(72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div className="absolute top-1/2 -translate-y-1/2 right-[0px] w-[calc(72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-72px-72px-6px-6px-5px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div
            className={`absolute top-1/2 -translate-x-1/2 left-[72px] translate-y-[calc(-50%-9px)]`}
          >
            <Image src="/assets/icon_start_point.png" width={12} />
          </div>

          <div
            className={`absolute top-1/2 translate-x-1/2 right-[72px] translate-y-[calc(-50%+9px)]`}
          >
            <Image src="/assets/icon_end_point.png" width={12} />
          </div>
        </div>

        <div ref={startPointRef}>
          <div
            className={`absolute top-1/2 -translate-x-1/2 left-[72px] translate-y-[calc(-50%-45px)]`}
          >
            <Image src="/assets/icon_map_pin.png" height={36} width={36} />
          </div>
          <div
            className={`absolute h-[50%] left-1/2 top-1/2 -translate-y-full -translate-x-1/2 w-[calc(100%-72px-72px+12px+12px)]`}
          >
            <div
              className={`absolute bottom-[0%] pb-[65px] text-left text-[#E5E9EDE5] font-extrabold text-[40px]`}
            >
              {startPointName}
            </div>
          </div>
        </div>

        <div ref={endPointRef}>
          <div
            className={`absolute top-1/2 translate-x-1/2 right-[72px] translate-y-[calc(-50%+45px)]`}
          >
            <Image
              src="/assets/icon_destination_flag.png"
              height={36}
              width={36}
            />
          </div>

          <div
            className={`absolute h-[50%] left-1/2 top-1/2 -translate-x-1/2 w-[calc(100%-72px-72px+12px+12px)]`}
          >
            <div
              className={`absolute top-[0%] right-[0%] pt-[65px] text-right text-[#E5E9EDE5] font-extrabold text-[40px]`}
            >
              {endPointName}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const DragBlock = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const animation = () => {
      divRef.current.style.display = isEnableDragRef.current ? "none" : "";
      animationRef.current = requestAnimationFrame(() => {
        animation();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        animation();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);
    return <div ref={divRef} className={`fullscreen_div opacity-[0]`}></div>;
  };

  const BlackScreen = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const opacityRef = useRef<number>(0);
    const EACH_OPACITY = 0.1;
    const keepCheckLoading = () => {
      if (!isDisplayBlackScreenRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);
    return (
      <div
        ref={divRef}
        className={`fullscreen_div pointer-events-none bg-black z-[60]`}
      ></div>
    );
  };

  const ContinueButton = () => {
    const isShowNavigationContinueButton = useNavigationStore(
      (state) => state.isShowNavigationContinueButton,
    );
    const hasUserInteraction = useAppStore((state) => state.hasUserInteraction);
    const setHasUserInteraction = useAppStore(
      (state) => state.setHasUserInteraction,
    );
    const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);

    const { readText } = useMessagePlayer();
    return isShowNavigationContinueButton ? (
      <div
        className={`fullscreen_div flex items-center justify-center pointer-events-none`}
      >
        <div
          className={`flex flex-col w-[100px] h-[100px] bg-[#7676808C] items-center justify-center rounded-xl cursor-pointer pointer-events-auto`}
          onClick={() => {
            if (!hasUserInteraction) {
              readText("", voiceLanguage, true);
              setHasUserInteraction(true);
            }

            setIsShowNavigationContinueButton(false);
            isWaitingUserContinue.current = false;
            resumeAutoPlay(0);
          }}
        >
          <div className={`text-center`}>
            <Image
              src={"/assets/icon_navigation_play.png"}
              width={36}
              height={36}
            />
          </div>
          <div className={`text-center text-white`}>Continue</div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const RestartButton = () => {
    const isShowNavigationRestartButton = useNavigationStore(
      (state) => state.isShowNavigationRestartButton,
    );
    return isShowNavigationRestartButton ? (
      <div
        className={`fullscreen_div flex items-center justify-center pointer-events-none`}
      >
        <div
          className={`flex flex-col w-[100px] h-[100px] bg-[#7676808C] items-center justify-center rounded-xl cursor-pointer pointer-events-auto`}
          onClick={() => {
            setIsShowNavigationRestartButton(false);
            setCameraMode(0);
            isDisplayAvatarRef.current = false;
            resetSlider();
            resetPosition();

            // resumeAutoPlay(1);
          }}
        >
          <div className={`text-center`}>
            <Image
              src={"/assets/icon_navigation_repeat.png"}
              width={36}
              height={36}
            />
          </div>
          <div className={`text-center text-white`}>Restart</div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  console.log(
    "NavigationPage component rendered , if this keep showing, something wrong",
  );

  return (
    <>
      <div className="absolute top-0 left-0 w-full h-full">
        <DataController />
        <Scene />
        <ChangeFloorScreen />
        <WatermarkScreen />
        <DebugKeyListener />
        <EnterLoading />
        <StartEndPoint />
        <ContinueButton />
        <RestartButton />
        <LoadingMask />
        <BlackScreen />
        <DragBlock />
      </div>
    </>
  );
}
